// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@mcmc/XDL/types";

export default {
    primary: {
        main: "#A80331",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#707070",
        contrast: "#FFFFFF",
    },
    tertiary: {
        main: "#F4F4F4",
        contrast: "#A80331",
    },
    common: {
        background: "#F4F4F4",
        backgroundContrast: "#212121",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#B7B7B7",
        disabled: "#CCCCCC",
        ui1: "#4A4A4A",
        ui2: "#B7B7B7",
        ui3: "#E8E8E8",
        ui4: "#F4F4F4",
        brand3: "#6FA618",
        eStoryAccount: {
            main: "#4A4A4A",
            contrast: "#FFFFFF",
        },
        black: "#000000",
    },
    text: {
        main: "#212121",
        inverse: "#FFFFFF",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#A80331",
    },
    success: {
        main: "#008649",
        contrast: "#C0E2D3",
    },
    danger: {
        main: "#E63E30",
        contrast: "#F9CFCC",
    },
    warning: {
        main: "#FAAB19",
        contrast: "#FEEAC6",
    },
    info: {
        main: "#0458AB",
        contrast: "#C0D5EA",
    },
    navigation: {
        primary: {
            main: "#212121",
            text: {
                main: "#FFFFFF",
                hover: "",
            },
        },
        secondary: {
            main: "#4A4A4A",
            text: {
                main: "#FFFFFF",
                hover: "",
            },
        },
    },
    footer: {
        main: "#212121",
        text: "",
    },
} as xBaseTheme["colors"];
